export default __webpack_public_path__ + "static/media/account-arrow-left.060b7b18.svg";